import React from 'react'

function TenderTextSwiveljet() {
  return (
    <embed src="\pdfs\EAT1.2.4_SW_Swivel_jet_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSwiveljet